/**
 * Abhinav Mishra V2 — production enhancements
 * Safe, dependency-light motion + resilient preloader.
 */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;

  function safeSessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function safeSessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }

  function unlockPage() {
    root.style.overflow = '';
    if (body) body.style.overflow = '';
  }

  function removePreloader(preloader) {
    if (!preloader || !preloader.parentNode) return;
    preloader.classList.add('is-ready');
    preloader.style.opacity = '0';
    preloader.style.transform = 'translate3d(0,-100%,0)';
    window.setTimeout(function () {
      if (preloader && preloader.parentNode) preloader.parentNode.removeChild(preloader);
      unlockPage();
    }, 650);
  }

  function waitForHeroMedia(timeout) {
    return new Promise(function (resolve) {
      var main = doc.getElementById('main');
      if (!main) { resolve(); return; }

      var media = main.querySelector('video, img');
      if (!media) { resolve(); return; }

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }

      if (media.tagName === 'IMG') {
        if (media.complete && media.naturalWidth > 0) { finish(); return; }
        media.addEventListener('load', finish, { once: true });
        media.addEventListener('error', finish, { once: true });
      } else {
        if (media.readyState >= 2) { finish(); return; }
        media.addEventListener('loadeddata', finish, { once: true });
        media.addEventListener('canplay', finish, { once: true });
        media.addEventListener('error', finish, { once: true });
      }

      window.setTimeout(finish, timeout);
    });
  }

  function initPreloader() {
    var preloader = doc.getElementById('am-preloader');
    if (!preloader) return;

    var isHomepage = body && (
      body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname === ''
    );

    if (!isHomepage) {
      preloader.remove();
      return;
    }

    var forcePreview = false;
    try { forcePreview = new URLSearchParams(window.location.search).get('am_preloader') === '1'; } catch (e) {}

    if (safeSessionGet('am_preloader_seen') && !forcePreview) {
      preloader.remove();
      return;
    }
    safeSessionSet('am_preloader_seen', '1');

    var logo = preloader.querySelector('.am-preloader__logo');
    if (!logo) { preloader.remove(); return; }

    root.style.overflow = 'hidden';
    body.style.overflow = 'hidden';

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var minDisplay = reduced ? 450 : 850;
    var start = Date.now();

    requestAnimationFrame(function () {
      logo.style.transition = reduced ? 'none' :
        'opacity .55s cubic-bezier(.22,1,.36,1), transform .65s cubic-bezier(.22,1,.36,1)';
      logo.style.opacity = '1';
      logo.style.transform = 'translate3d(0,0,0) scale(1)';
    });

    Promise.all([
      waitForHeroMedia(1600),
      new Promise(function (resolve) { window.setTimeout(resolve, minDisplay); })
    ]).then(function () {
      var elapsed = Date.now() - start;
      var remaining = Math.max(0, 1000 - elapsed);
      window.setTimeout(function () { removePreloader(preloader); }, remaining);
    });

    // Absolute safety net: never keep a visitor behind the preloader.
    window.setTimeout(function () {
      removePreloader(preloader);
    }, 2600);
  }

  function initLuxuryMotion() {
    // Motion layer is intentionally homepage-only. Product/collection templates
    // use their own theme lifecycle and must never be hidden by this observer.
    var isHomepage = body && (body.classList.contains('template-index') || window.location.pathname === '/' || window.location.pathname === '');
    if (!isHomepage) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    root.classList.add('am-motion-ready');

    var sections = doc.querySelectorAll('#main > .shopify-section');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    Array.prototype.forEach.call(sections, function (section) {
      section.classList.add('am-reveal');
    });

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(sections, function (section) { observer.observe(section); });
  }

  function initViewportHeight() {
    var setHeight = function () {
      root.style.setProperty('--window-height', window.innerHeight + 'px');
    };
    setHeight();
    var ticking = false;
    window.addEventListener('resize', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { setHeight(); ticking = false; });
    }, { passive: true });
  }

  function init() {
    initViewportHeight();
    initPreloader();
    initLuxuryMotion();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
}());
